
const URL = "https://" + window.location.host;

export default URL 


